export default [
  {
    label: "Clientes",
    icon: "fas fa-user-cog",
    items: [
      {
        label: "Clientes inativos - Atendimento",
        to: "/relationship/clients-not-transacting",
        icon: "fas fa-user-times",
        controller: "Merchant",
        action: "ListNotTransacting"
      },
      {
        label: "Clientes inativos - Comercial",
        to: "/relationship/clients-not-transacting-commercial",
        icon: "fas fa-user-slash",
        controller: "Merchant",
        action: "ListNotTransacting"
      },
      {
        label: "Contratos dos clientes",
        to: "/relationship/merchant-contracts",
        icon: "fas fa-file-signature",
        controller: "Merchant",
        action: "ListMerchantContract"
      },
      {
        label: "Documentos dos clientes",
        to: "/relationship/merchant-docs",
        icon: "fas fa-file-alt",
        controller: "MerchantDoc",
        action: "List"
      },
      // {
      //   label: "Reuniões com os clientes",
      //   to: "/relationship/merchant-trainings",
      //   icon: "fas fa-headset",
      //   controller: "Training",
      //   action: "List"
      // },
      {
        label: "Atendimento ao cliente",
        to: "/relationship/customer-service",
        icon: "fas fa-address-book",
        controller: "CustomerService",
        action: "List"
      },
      {
        label: "Desempenho dos clientes",
        to: "/relationship/merchant-metrics",
        icon: "fas fa-user-tag",
        controller: "ClientMaintenance",
        action: "List"
      }
    ]
  },
  {
    label: "Parceiros",
    icon: "fas fa-user-cog",
    items: [
      {
        label: "Atendimento ao parceiro",
        to: "/relationship/parceiro-atendimento",
        icon: "fas fa-address-book",
        controller: "ParceiroAtendimento",
        action: "List"
      },
      {
        label: "Contratos dos parceiros",
        to: "/relationship/partner-contracts",
        icon: "fas fa-file-contract",
        controller: "Partner",
        action: "ListPartnerContract"
      },
      {
        label: "Documentos dos parceiros",
        to: "/relationship/partner-docs",
        icon: "fas fa-id-card",
        controller: "PartnerDoc",
        action: "List"
      },
      // {
      //   label: "Reuniões com os parceiros",
      //   to: "/relationship/partner-trainings",
      //   icon: "fas fa-headset",
      //   controller: "Training",
      //   action: "List"
      // },
      {
        label: "Solicitações de alteração de parceiro",
        to: "/relationship/merchant-solicitations",
        icon: "fas fa-user-check",
        controller: "MerchantSolicitation",
        action: "List"
      }
    ]
  },
  // {
  //   label: "Reuniões com os prospects",
  //   to: "/relationship/prospect-trainings",
  //   icon: "fas fa-headset",
  //   controller: "Training",
  //   action: "List"
  // },
  // {
  //   label: "Melhorias sugeridas",
  //   to: "/relationship/training-improvements",
  //   icon: "fas fa-lightbulb",
  //   controller: "TrainingImprovement",
  //   action: "ListScore"
  // },
  // {
  //   separator: true
  // },
  // {
  //   label: "Consultar cobranças",
  //   to: "/relationship/transaction-charge",
  //   icon: "fas fa-receipt",
  //   controller: "Transaction",
  //   action: "ListCharge"
  // }, 
  // Task: 6066 - Consultar DDA removido
  {
    separator: true
  },
  {
    label: "Solicitações de renovação",
    to: "/relationship/prospect-histories",
    icon: "fas fa-check-double",
    controller: "ProspectHistory",
    action: "List"
  }
];


// WEBPACK FOOTER //
// ./src/data/menu-item-internal/relationship-menu.js